import { render, staticRenderFns } from "./PersonalInfos.vue?vue&type=template&id=a13e1838&scoped=true&"
import script from "./PersonalInfos.vue?vue&type=script&lang=js&"
export * from "./PersonalInfos.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInfos.vue?vue&type=style&index=0&id=a13e1838&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13e1838",
  null
  
)

export default component.exports